import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { threadId } from "worker_threads";

export interface TwoPanelSelectorProps {
    field?: any;
    form?: any;
    items?: { label: string; value: string }[];
    completeList?: any[];
    givenid?: string;
}

const shoudComponentHaveValue = (completeList, value) => {
    return (
        completeList !== undefined &&
        completeList.length > 0 &&
        value !== undefined
    );
};

export default class BaseTwoPanelSelector extends Component<
    TwoPanelSelectorProps,
    {}
> {
    onChangeHandler = e => {
        this.props.form.setFieldValue(this.props.field.name, e);
    };

    render() {
        let { value } = this.props.field;
        if (shoudComponentHaveValue(this.props.completeList, value)) {
            value = this.props.completeList.filter(item =>
                this.props.field.value.includes(item.value)
            );
        }

        return (
            <div id={this.props.givenid + "ButtonSelector"}>
                <Components.TwoPanelSelector
                    items={this.props.items}
                    enableMultipleSelection={true}
                    onChange={this.onChangeHandler}
                    value={value}
                />
            </div>
        );
    }
}
